import { combineReducers } from 'redux'
import { reducer as ScheduleReducer } from '../Containers/Welcome/Reducer'
import { reducer as IdentifyReducer } from '../Containers/Identify/Reducer'

export default combineReducers({
	schedule: ScheduleReducer,
	identify: IdentifyReducer,
})
